import React from 'react';
import { Card, CardContent, Grid, Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import SubCard from 'src/components/cards/SubCard';
import { styled } from '@mui/material/styles';

// styles
const IconWrapper = styled('div')({
    position: 'absolute',
    left: '-17px',
    bottom: '-27px',
    color: '#fff',
    transform: 'rotate(25deg)',
    '&> svg': {
        width: '100px',
        height: '100px',
        opacity: '0.35'
    }
});

const ServiceInformationSkeleton = () => {

    return (
        <Grid container spacing={2}>
            <Grid
                size={{
                    xs: 12,
                    sm: 12,
                    md: 6
                }}>
                <SubCard title={<Skeleton width="60%" />}>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <Grid container spacing={3} justifyContent="center" alignItems="center">
                                <Grid size={12}>
                                    <Typography variant="h6" gutterBottom style={{ textAlign: 'center' }}>
                                        <Skeleton width="40%" />
                                    </Typography>
                                </Grid>
                                {Array.from(new Array(3)).map((_, index) => (
                                    <Grid key={index}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Skeleton variant="circular" width={100} height={100} />
                                            <Typography variant="h6" gutterBottom>
                                                <Skeleton width="80%" />
                                            </Typography>
                                            <Typography variant="body2" gutterBottom>
                                                <Skeleton width="60%" />
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        {Array.from(new Array(12)).map((_, index) => (
                            <Grid
                                key={index}
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    md: index % 2 === 0 ? 4 : 8
                                }}>
                                <Skeleton variant="rectangular" height={56} />
                            </Grid>
                        ))}
                    </Grid>
                </SubCard>
            </Grid>

            <Grid
                size={{
                    xs: 12,
                    sm: 12,
                    md: 6
                }}>
                <SubCard title={<Skeleton width="40%" />}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Box>
                                <Skeleton variant="rectangular" height={200} />
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <Grid container spacing={3}>
                                <Grid style={{ textAlign: 'center' }} size={12}>
                                    <Card sx={{ position: 'relative', color: '#e0e0e0' }} style={{ backgroundColor: '#e0e0e0' }}>
                                        <CardContent>
                                            <IconWrapper>
                                                <Skeleton variant="circular" width={100} height={100} />
                                            </IconWrapper>
                                            <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1}>
                                                <Grid
                                                    size={{
                                                        sm: 12
                                                    }}>
                                                    <Skeleton variant="text" width="60%" height={40} />
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        sm: 12
                                                    }}>
                                                    <Skeleton variant="text" width="80%" height={20} />
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid size={12}>
                                    <Card sx={{ background: '#e0e0e0', position: 'relative', color: '#e0e0e0' }} style={{ backgroundColor: '#e0e0e0' }}>
                                        <CardContent>
                                            <IconWrapper>
                                                <Skeleton variant="circular" width={100} height={100} />
                                            </IconWrapper>
                                            <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1}>
                                                <Grid
                                                    size={{
                                                        sm: 12
                                                    }}>
                                                    <Skeleton variant="text" width="60%" height={40} />
                                                </Grid>
                                                <Grid
                                                    size={{
                                                        sm: 12
                                                    }}>
                                                    <Skeleton variant="text" width="80%" height={20} />
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>
        </Grid>
    );
};

export default ServiceInformationSkeleton;
